import { useTranslation } from '../presentation/common/useTranslation.js';
import { Link } from 'react-router-dom';

import './KarmaScoreLink.css';
import { scrollToKarmaBarometer } from '../utils/scrollToKarmaBarometer';

export default function KarmaScoreLink({ children, to = '/profile#karma-barometer', className = '', style, title }) {
  const { t } = useTranslation();
  return <Link
    to={to}
    className={`karma-score-link ${className}`.trim()}
    style={style}
    title={title || t('karma.open_barometer')}
    aria-label={`${t('karma.open_barometer')}: ${children}`}
    onClick={event => {
      event.stopPropagation();
      const destination = new URL(to, window.location.href);
      if (destination.pathname === window.location.pathname && destination.hash === '#karma-barometer') {
        requestAnimationFrame(scrollToKarmaBarometer);
      }
    }}
  >{children}</Link>;
}
